import React from 'react'
import { Modal, ModalBody } from 'reactstrap'

const DeletePopup = ({ isDeleteModalOpen, toggle, size = 'md', children }) => {
  return (
    <Modal size={size} centered isOpen={isDeleteModalOpen} toggle={toggle}>
      <ModalBody className="p-5">
        {' '}
        <div className="form-header">
          <h3 className="modal_title_text text-center">Delete</h3>
          <p className="modal_highlight_text text-center">Are you sure you want to delete?</p>
        </div>
        {children}
      </ModalBody>
    </Modal>
  )
}

export default DeletePopup
